var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('template',{slot:"waiting"},[_c('LoaderComponent')],1),_c('v-container',[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }